export const isLinkValid = link => {
  return (link.length > 0 && !(link.includes(';') || link.includes(' ') || link.includes('"') || link.includes('\'')) && !(/\s+/.test(link)));
}

export const isLinkNameValid = linkName => {
  return !((/[^\w-_]+/).test(linkName));
}
